export const IM_DFM_RESET = 'IM_DFM_RESET'
export const IM_DFM_SET_ACTIVE_SLIDE_ID = 'IM_DFM_SET_ACTIVE_SLIDE_ID'
export const IM_DFM_SET_SLIDES = 'IM_DFM_SET_SLIDES'
export const IM_DFM_UPDATE_SLIDE = 'IM_DFM_UPDATE_SLIDE'
export const IM_DFM_SET_SHOULD_SYNC = 'IM_DFM_SET_SHOULD_SYNC'
